import { isApiError } from "@/utils/errorMessage";

/** Standard CTMS document upload cap (eTMF, regulatory, site activation, finance, monitoring UI). */
export const UPLOAD_MAX_BYTES_10MB = 10 * 1024 * 1024;

export const UPLOAD_MAX_10MB_MESSAGE = "File too large. Maximum size is 10MB";

export function uploadFileTooLargeDetail(
  fileName: string,
  sizeBytes: number,
): string {
  const sizeMb = Math.ceil((sizeBytes / (1024 * 1024)) * 10) / 10;
  return `"${fileName}" is ${sizeMb} MB. ${UPLOAD_MAX_10MB_MESSAGE}`;
}

export function assertUploadWithin10Mb(file: File): void {
  if (file.size > UPLOAD_MAX_BYTES_10MB) {
    throw new Error(uploadFileTooLargeDetail(file.name, file.size));
  }
}

/** Map gateway/multer 413 responses to the standard user-facing cap message. */
export function uploadSizeLimitApiMessage(error: unknown): string | null {
  if (isApiError(error) && error.status === 413) {
    return UPLOAD_MAX_10MB_MESSAGE;
  }
  return null;
}
